export const PLAN_CODES = ["IND-1H", "DUO-1H", "IND-2H", "DUO-2H"] as const;
export type PlanCode = (typeof PLAN_CODES)[number];

export interface Plan {
  code: PlanCode;
  name: string;
  /** Mensalidade por aluno, em centavos. */
  priceCents: number;
  weeklyMinutes: number;
  daysPerWeek: number;
  isDuo: boolean;
  aiMinutes: number;
  teacherBps: number;
  sellerBps: number;
  tagline: string;
}

export const PLANS: Record<PlanCode, Plan> = {
  "IND-1H": {
    code: "IND-1H",
    name: "Individual 1h",
    priceCents: 19_999,
    weeklyMinutes: 60,
    daysPerWeek: 1,
    isDuo: false,
    aiMinutes: 120,
    teacherBps: 5000,
    sellerBps: 500,
    tagline: "1h por semana com professor",
  },
  "DUO-1H": {
    code: "DUO-1H",
    name: "Dupla 1h",
    priceCents: 13_999,
    weeklyMinutes: 60,
    daysPerWeek: 1,
    isDuo: true,
    aiMinutes: 120,
    teacherBps: 5000,
    sellerBps: 500,
    tagline: "Por aluno, mesmo horário",
  },
  "IND-2H": {
    code: "IND-2H",
    name: "Individual 2h",
    priceCents: 37_999,
    weeklyMinutes: 120,
    daysPerWeek: 2,
    isDuo: false,
    aiMinutes: 120,
    teacherBps: 5526,
    sellerBps: 500,
    tagline: "2h por semana, em dois dias",
  },
  "DUO-2H": {
    code: "DUO-2H",
    name: "Dupla 2h",
    priceCents: 24_999,
    weeklyMinutes: 120,
    daysPerWeek: 2,
    isDuo: true,
    aiMinutes: 180,
    teacherBps: 5880,
    sellerBps: 500,
    tagline: "Por aluno, dois dias",
  },
};

export function isPlanCode(value: string): value is PlanCode {
  return (PLAN_CODES as readonly string[]).includes(value);
}

export function getPlan(code: PlanCode): Plan {
  return PLANS[code];
}

/** Duração de cada aula da semana (60 nos planos de 1h e nos de 2h em dois dias). */
export function sessionMinutes(plan: Pick<Plan, "weeklyMinutes" | "daysPerWeek">): number {
  return plan.weeklyMinutes / plan.daysPerWeek;
}

/** Valor da cobrança: na dupla com um pagador, o dobro da mensalidade. */
export function chargeCents(
  plan: Pick<Plan, "priceCents" | "isDuo">,
  singlePayer: boolean,
): number {
  return plan.isDuo && singlePayer ? plan.priceCents * 2 : plan.priceCents;
}

/** Quantos alunos a matrícula ocupa na capacidade do professor. */
export function studentsPerEnrollment(plan: Pick<Plan, "isDuo">): number {
  return plan.isDuo ? 2 : 1;
}
